export type Project = {
  name: string
  wordmark: string
  tagline: string
  description: string
  stat: string
  statLabel: string
  href: string
}

export const projects: Project[] = [
  {
    name: 'Vite',
    wordmark: 'vite',
    tagline: 'Next generation frontend tooling',
    description:
      'The dev server and build tool that starts instantly, ships hot updates the moment you save, and powers most modern frameworks.',
    stat: '28M',
    statLabel: 'weekly downloads',
    href: '#vite',
  },
  {
    name: 'Vitest',
    wordmark: 'vitest',
    tagline: 'A test runner that keeps up with you',
    description:
      'Unit, component, and browser tests sharing one config with your app. Watch mode re-runs only what your change actually touched.',
    stat: '9M',
    statLabel: 'weekly downloads',
    href: '#vitest',
  },
  {
    name: 'Rolldown',
    wordmark: 'rolldown',
    tagline: 'Rust-powered bundler, Rollup-compatible',
    description:
      'A drop-in successor to the Rollup pipeline, rebuilt in Rust for production builds that finish in a fraction of the time.',
    stat: '1.4M',
    statLabel: 'weekly downloads',
    href: '#rolldown',
  },
  {
    name: 'Oxc',
    wordmark: 'oxc',
    tagline: 'The JavaScript oxidation compiler',
    description:
      'Parser, linter, resolver, transformer, and minifier written in Rust — the shared foundation the rest of the toolchain is built on.',
    stat: '6M',
    statLabel: 'weekly downloads',
    href: '#oxc',
  },
]

export const toolchainSteps = [
  {
    label: 'parse',
    title: 'One parser, one AST',
    body: 'Linting, transforms, and bundling all read the same syntax tree instead of re-parsing your source four times.',
  },
  {
    label: 'transform',
    title: 'Transforms in Rust',
    body: 'TypeScript, JSX, and downleveling happen natively, so cold starts stop being the price of a large codebase.',
  },
  {
    label: 'bundle',
    title: 'Dev and prod agree',
    body: 'The same module graph serves your dev server and your production bundle. No more works-in-dev-only bugs.',
  },
  {
    label: 'test',
    title: 'Tests share the config',
    body: 'Your aliases, plugins, and env land in the test runner automatically, because it is the same pipeline.',
  },
]

export const posts = [
  {
    date: '2026.08.14',
    tag: 'engineering',
    title: 'Rolldown enters the Vite 8 default pipeline',
    excerpt:
      'What changed under the hood, what you should measure on your own repo, and how to opt out if you hit an edge case.',
  },
  {
    date: '2026.06.02',
    tag: 'release',
    title: 'Oxc formatter reaches feature parity',
    excerpt:
      'A formatter that matches the community standard byte for byte, running on the AST your linter already built.',
  },
  {
    date: '2026.04.19',
    tag: 'company',
    title: 'Why a company for open source tooling',
    excerpt:
      'Maintainers, funding, and the boring infrastructure work that keeps a toolchain alive for the next decade.',
  },
]

export const stats = [
  { value: '44M+', label: 'weekly npm downloads' },
  { value: '4', label: 'core open source projects' },
  { value: '100%', label: 'MIT licensed' },
  { value: '2024', label: 'founded' },
]
